import { getQueryParams } from '../routing/getQueryParams';
import { getIsExistingUserSession, getIsNewPortalCreated } from '../store/app/selectors';
import { getActiveExperimentsIds, getParameter } from '../store/experiments/selectors';
import { checkIfIsACQ111AndExposureTracked, getHasExposureBeenTrackedACQ111 } from './acq111/acq111Tracking';
import { getActiveCopyExperimentIds } from './copyExperimentUtils';
import { ExperimentIdentifier } from './ExperimentIdentifier';
import { ExperimentKeys } from './ExperimentKeys';
import { getExperimentsConfig } from './getExperimentsConfig';
import { getUtk } from './getUtk';
import { getAllUtkExperiments, isPortalExperiment } from './getUtkExperiments';
import { getHasExposureBeenTracked } from './useExperiment';
const EXPERIMENT_BACKDOOR_PARAM = 'exp-disabled';
export const experimentsEnabled = () => {
  const queryParams = getQueryParams();
  const manuallyDisabled = !!queryParams[EXPERIMENT_BACKDOOR_PARAM];
  return !manuallyDisabled;
};
export const getPortalExperiments = () => {
  const experiments = getExperimentsConfig();
  return Object.keys(experiments).filter(experimentKey => isPortalExperiment(experimentKey), []);
};
export const getExperimentsToFetch = ({
  identifierPhase
}) => {
  if (!experimentsEnabled()) {
    return [];
  }

  if (identifierPhase === ExperimentIdentifier.PortalId) {
    return getPortalExperiments();
  }

  return getAllUtkExperiments();
};
export const getPreAcountCreatedExperimentIdentifierPhase = () => {
  return getUtk() ? ExperimentIdentifier.Utk : ExperimentIdentifier.Uuid;
};
export const getExperimentIdentifierPhase = state => {
  if (getIsNewPortalCreated(state)) {
    return ExperimentIdentifier.PortalId;
  }

  return getPreAcountCreatedExperimentIdentifierPhase();
};
export const getActiveExperimentsParametersForInitiateVerification = state => {
  const activeExperimentsIds = getActiveExperimentsIds(state);
  const activeCopyExperimentIds = getActiveCopyExperimentIds(state);
  const activeExperimentsParameters = [...activeExperimentsIds, ...activeCopyExperimentIds, ...(getHasExposureBeenTrackedACQ111() ? [ExperimentKeys.ACQ111] : [])].map(activeExperimentId => {
    const activeExperimentParameter = getParameter(state, activeExperimentId);
    return `${activeExperimentId}-group-${activeExperimentParameter}`;
  });
  return activeExperimentsParameters;
};
export const getActiveExperimentsParameters = state => {
  const activeExperimentsParametersFromState = state.experiments.activeExperimentsParameters;
  const activeExperimentsIds = getActiveExperimentsIds(state);
  const activeCopyExperimentIds = getActiveCopyExperimentIds(state);
  const activeExperimentsParameters = [...activeExperimentsIds, ...activeCopyExperimentIds, ...(getHasExposureBeenTrackedACQ111() ? [ExperimentKeys.ACQ111] : [])].filter(activeExperimentId => getHasExposureBeenTracked(activeExperimentId) || checkIfIsACQ111AndExposureTracked(activeExperimentId)).map(activeExperimentId => {
    const activeExperimentParameter = getParameter(state, activeExperimentId);
    return `${activeExperimentId}-group-${activeExperimentParameter}`;
  });
  const filteredExperimentParams = activeExperimentsParameters.filter(activeExperimentParam => !activeExperimentsParametersFromState.includes(activeExperimentParam));
  return [...activeExperimentsParametersFromState, ...filteredExperimentParams];
};
export const getIsNewUserExperiment = state => {
  return !getIsExistingUserSession(state);
};